// See corresponding CSS version in `src/styles/_tools.scss`

export default {
  touch: '(pointer: coarse)',
  cursor: '(pointer: fine)',
  hover: '(hover: hover)',
  still: '(prefers-reduced-motion)',
  sm: '(max-width: 767px)',
  md: '(min-width: 768px) and (max-width: 1024px)',
  lg: '(min-width: 1025px)',
};
